import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const dividerDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
  };
};
